import { api } from "@/lib/api";

export type WecomUser = {
  id: number;
  userid: string;
  name: string | null;
  avatar_url: string | null;
};

export type WecomUsersList = {
  wecom_users: WecomUser[];
};

/** 展示名：name → userid */
export function wecomUserDisplayName(
  user: Pick<WecomUser, "userid" | "name"> | { userid: string; name?: string | null },
): string {
  const name = user.name?.trim();
  if (name) return name;
  return user.userid;
}

export async function listWecomUsers(
  accountId: string | number,
  opts?: { q?: string; limit?: number },
): Promise<WecomUsersList> {
  const params = new URLSearchParams();
  if (opts?.q?.trim()) params.set("q", opts.q.trim());
  if (opts?.limit != null && opts.limit > 0) params.set("limit", String(opts.limit));
  const qs = params.toString();
  return api.fetchForAccount<WecomUsersList>(
    accountId,
    `/account/wecom_users${qs ? `?${qs}` : ""}`,
  );
}

export function wecomUserNameByUserid(users: WecomUser[]): Record<string, string> {
  const map: Record<string, string> = {};
  for (const user of users) {
    map[user.userid] = wecomUserDisplayName(user);
  }
  return map;
}

export function formatFollowUserids(
  userids: string[],
  nameByUserid: Record<string, string>,
  separator = ", ",
): string {
  return userids.map((id) => nameByUserid[id] ?? id).join(separator);
}
